import React from 'react';
import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import {
  FeaturedLinksWrapper,
  FeaturedLinksTitle,
  FeaturedLinksContent,
  FeaturedLink,
} from '../FeaturedLinks/FeaturedLinks';

export const FeaturedCountries: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { lg } = useMediaQuery();

  const countries = [
    T('home.in_country.Austria'),
    T('home.in_country.Belgium'),
    T('home.in_country.France'),
    T('home.in_country.Germany'),
    T('home.in_country.Iceland'),
    T('home.in_country.Italy'),
    T('home.in_country.Netherlands'),
    T('home.in_country.Portugal'),
    T('home.in_country.Spain'),
    T('home.in_country.Switzerland'),
  ];
  const countriesLinks: FeaturedLink[] = countries.map(countryName => ({
    textContent: countryName,
    url: urlResolver.getCountryUrl(
      countryName.replace(/-/g, '~').replace(/ /g, '-'),
    ),
    title: countryName,
  }));

  const maxItemsPerColumn = lg ? 1 : 8;
  const columnWidth = 1;

  return (
    <FeaturedLinksWrapper slightlyGray>
      <FeaturedLinksTitle titles={[T('home_page_featured_countries')]} />
      <FeaturedLinksContent
        items={countriesLinks}
        maxItemsPerColumn={maxItemsPerColumn}
        columnWidth={columnWidth}
      />
    </FeaturedLinksWrapper>
  );
};
